module.exports = __webpack_public_path__ + "img/685b895.png";